export default __webpack_public_path__ + "static/media/box-arrow-up_blue.40e9c3ed.svg";